import { fetchConToken } from "../../helpers/fetch";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import { agregarNotificacion } from "../notificaciones";
import { areas } from "../../helpers/areas";

export const enviarPreafiliadoBandeja = (idAfiliado,idGrupo) => async (dispatch, getState) => {
  try{
    dispatch(startSpinner());
    //const response = await fetchConToken(`Preafiliados/enviar/${idAfiliado}/${idGrupo}`, {}, "PUT");
    const state = getState();
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    const response = await fetchConToken(`Preafiliados/enviar/${idAreaUsuario}/${idAfiliado}/${idGrupo}`, {}, "POST");
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log( respuesta );
      if (!response.ok) throw respuesta.errores;
      dispatch( agregarNotificacion(idGrupo, respuesta.estado, idAreaUsuario, respuesta.idArea, null, respuesta.id_afiliado ) );
      //idGrupoFamiliar, estado, idBandejaOrigen, idBandejaDestino, observacion, idAfiliado
      dispatch({
        type: "envioBandejaPreafiliado",
        payload: respuesta,
      });
      dispatch(startAlerta(`Envio Exitoso`,'success','La documentación fue enviada correctamente'));
    } else {
      console.log("error de post precarga", response);
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    dispatch(startAlerta("Error al enviar la PreAfiliacion", "warning", `¡Error!`));
    console.log( err.mensaje );
  }
  
};

export const aprobarPreafiliadoBandeja = (idAfiliado,idGrupo) => async (dispatch, getState) => {
  try{
    dispatch(startSpinner());
    const state = getState();
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    const response = await fetchConToken(`Preafiliados/aprobar/${idAreaUsuario}/${idAfiliado}/${idGrupo}`, {}, "PUT");
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log( respuesta );
      if (!response.ok) throw respuesta.errores;
      dispatch( agregarNotificacion(idGrupo, respuesta.estado, idAreaUsuario, respuesta.idArea, null, respuesta.id_afiliado ) );
      //idGrupoFamiliar, estado, idBandejaOrigen, idBandejaDestino, observacion, idAfiliado
      dispatch({
        type: "envioBandejaPreafiliado",
        payload: respuesta,
      });
      dispatch(startAlerta(`Envio Exitoso`,'success','La aprobación fue realizada correctamente'));
      dispatch(finishSpinner());
    } else {
      console.log("error de post precarga", response);
    }
  } catch (err) {
    dispatch(finishSpinner());
    dispatch(startAlerta("Error al aprobar la PreAfiliacion. " + err.mensaje, "warning", `¡Error!`));
    console.log( err.mensaje );
  }
};

export const observarPreafiliadoBandeja = (idAfiliado,idGrupo, observacion) => async (dispatch, getState) => {
  try{
    dispatch(startSpinner());
    const state = getState();
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);

    const data = { idArea: idAreaUsuario, idAfiliado, idGrupoFamiliar: idGrupo, textoObservacion: observacion };
    const response = await fetchConToken(`Preafiliados/rechazar`, data, "PUT");

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      console.log( respuesta );
      if (!response.ok) throw respuesta.errores;
      dispatch( agregarNotificacion(idGrupo, respuesta.estado, idAreaUsuario, respuesta.idArea, null, respuesta.id_afiliado, observacion ) );
      //idGrupoFamiliar, estado, idBandejaOrigen, idBandejaDestino, observacion, idAfiliado
      dispatch({
        type: "envioBandejaPreafiliado",
        payload: respuesta,
      });
      dispatch(startAlerta(`Envio Exitoso`,'success','La observación fue realizada correctamente'));
    } else {
      console.log("error de post precarga", response);
    }
    dispatch(finishSpinner());
  }catch (err) {
    dispatch(finishSpinner());
    dispatch(startAlerta("Error al observar la PreAfiliacion", "warning", `¡Error!`));
    console.log( err.mensaje );
  }
};


/**********************************************FAMILIARES PREAFILIADOS**************************************************/

export const enviarPreafiliadoFamiliarBandeja = (idAfiliado,idGrupo) => async (dispatch, getState) => {
  try{
    dispatch(startSpinner());
    const state = getState();
    const { idArea: idAreaUsuario } = state.auth.areas.find(area => area.idArea === areas.Nacional || area.idArea === areas.Seccional);
    if (idAreaUsuario !== areas.Seccional) throw new Error('Solo pueden enviar Pre Afiliaciones de Familiares usuarios de Area Seccional');
    const response = await fetchConToken(`Preafiliados/EnviarFamiliar/${idAreaUsuario}/${idAfiliado}/${idGrupo}`, {}, "POST");
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      if (!response.ok) throw respuesta.errores;
      dispatch( agregarNotificacion(idGrupo, respuesta.estado, idAreaUsuario, respuesta.idArea, null, respuesta.id_afiliado ) );    //ver si va idAfiliado
      dispatch(startAlerta(`Envio Exitoso`,'success','La documentación fue enviada correctamente'));
    } else {
      console.log("error de post precarga", response);
    }
    dispatch(finishSpinner());
  } catch (err) {
    dispatch(finishSpinner());
    // dispatch(startAlerta("Error al enviar la PreAfiliacion", "warning", `¡Error!`));
    dispatch(startAlerta(err, "warning", `¡Error!`));
    console.log( err );
  }
  
};